// Buy on OWD will be on app.avalara.com/buy, infra Buy "buy" is in the hostname
// Check for case insensitive "buy" in hostname, if it's not there then we're in OWD
export const isOneWebDomainRuntime = (): boolean => !/buy/i.test(window.location.hostname);
